import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogPosts } from './BlogPage';
import { Calendar, User, Tag } from 'lucide-react';
import '../css/BlogDetailPage.css';

const BlogDetailPage = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  if (!post) return <div>Post not found.</div>;

  return (
    <div className='blog-detail-bg'>
    <div className="blog-detail-page">
      <div className="blog-detail-container">
      <Link to="/blogpage" className="back-link">← Back to Blog</Link>
        <h1 className="blog-title">{post.title}</h1>
        <div className="blog-meta">
          <span><User size={16} /> {post.author}</span>
          <span><Calendar size={16} /> {new Date(post.date).toLocaleDateString()}</span>
          <span>{post.readTime}</span>
        </div>

        <img src={post.image} alt={post.title} className="blog-image" />

        <div className="blog-content">
          <p>{post.content}</p>
        </div>
        <div className="blog-content">
          <p>{post.description}</p>
        </div>

        <div className="blog-tags">
          {post.tags.map(tag => (
            <span key={tag} className="tag">
              <Tag size={12} /> {tag}
            </span>
          ))}
        </div>

      </div>
    </div>
    </div>
  );
};

export default BlogDetailPage;
